// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".additional-coverage-details{padding:8px 20px 0px 20px}", "",{"version":3,"sources":["webpack://./src/components/CoverageList/CoverageDetails.scss"],"names":[],"mappings":"AAAA,6BACI,yBAAA","sourcesContent":[".additional-coverage-details{\n    padding: 8px 20px 0px 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
